import { useEffect, useState } from 'react';

import { InteractionManager } from 'react-native';

import { isWeb } from 'utils/responsiveness';

function useInteractionsFinished() {
    const [interactionsFinished, setInteratctionsFinished] = useState(isWeb);

    useEffect(() => {
        let interactionListener:
            | undefined
            | ReturnType<typeof InteractionManager.runAfterInteractions>;

        if (!isWeb) {
            interactionListener = InteractionManager.runAfterInteractions(
                () => {
                    setInteratctionsFinished(true);
                },
            );
        }

        return () => {
            if (interactionListener) {
                interactionListener.cancel();
            }
        };
    }, []);

    return interactionsFinished;
}

export default useInteractionsFinished;
